import {
  Navigate,
  Outlet,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import { useAtomValue } from "jotai";
import i18n from '@/i18n/config';

import { tokenAtom, isAuthenticatedAtom } from "@/store";

export default function GuestGuard() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const token = useAtomValue(tokenAtom);
  const isAuthenticated = useAtomValue(isAuthenticatedAtom);

  const isAuthed = Boolean(token) || Boolean(isAuthenticated);

  // If user is authed, redirect away from login to intended page or home
  if (isAuthed) {
    const redirect = searchParams.get("redirect");
    const target = redirect || "/";

    // Prevent loop if already at target
    if (location.pathname + location.search !== target) {
      return <Navigate replace to={target} />;
    }
  }

  return <Outlet />;
}
